import axios from "axios";
import React, { useEffect, useState } from "react";
import Constants from "../Variables/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ProductDetail = () => {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);

  const getSingleProduct = (id) => {
    axios
      .get(Constants.getUrls.getProduct + "/" + id)
      .then((resp) => {
        if (resp.data.status === "success") {
          if (resp.data.data) {
            setProduct(resp.data.data);
          }
        }
      })
      .catch((error) => {
        console.error("Error while fetching product:", error);
      });
  };

  useEffect(() => {
    getSingleProduct(id);
  }, [id]);

  const handleAddToCart = () => {
    if (!token) {
      toast.warning("Please Login To Add Product!")
      navigate('/login', { state: { product_id: product._id, isAddToCartRedirect: true } });
      return;
    }

    axios
      .post(Constants.postUrls.AddToCart, {
        product_id: product._id,
        quantity: 1,
      }, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((resp) => {
        if (resp.data.status === "success") {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.success("Product added to cart successfully!", {
            style: { backgroundColor: "green", color: "white" },
          });
        }
      })
      .catch((error) => {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      })
  };

  return (
    <div className="container mt-5">
      <h1 className="">Product Details</h1>
      <div className="d-flex flex-wrap gap-5 mt-5 justify-content-center align-items-center">
        {/* Product Image */}
        <div className="product-image">
          <img loading="lazy" 
            src={`${Constants.imgDomain}${product?.images[0]}`}
            alt={product?.title}
            className="img-fluid rounded shadow"
            style={{ maxWidth: "300px", maxHeight: "300px", objectFit: "cover" }}
          />
        </div>
        {/* Product Details */}
        <div className="product-info">
          <h2 className="mb-4">Name: <span className="text-primary">{product?.name}</span></h2>
          <h2 className="mb-4">Price: <span className="text-success">${product?.price}</span></h2>
          <button
            className="btn btn-warning btn-lg"
            onClick={handleAddToCart}
            disabled={!product}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
